import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
  transactionId: string;
  fileData: unknown;
}

export const useUploadMoneyTransferConfirmation = ({ fileData, customerId, transactionId }: IProps, onSuccess: ()=> void, onError: ()=> void) => useMutation(
  'uploadTransferConfirmation',
  async () => {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/transactions/${transactionId}/ach`, fileData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
  {
    onSuccess: () => {
      onSuccess();
    },
    onError: () => {
      onError();
    },
  },

);
